export const rootPath = '/reagents-tracker';
export const entityPath = '/reagents-tracker/:section';

export const i18Namespace = 'Reagents';
export const defaultSort = '';
